import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { personByDocument } from "../../store/person/actions";
export var GetPersonByDocument = function (trigger, document) {
    var dispatch = useDispatch();
    var enable = React.useState(true)[0];
    var page = React.useState(1)[0];
    var limit = React.useState(10)[0];
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePersonByDocument: (_a = state.Person.responsePersonByDocument) === null || _a === void 0 ? void 0 : _a.data,
            errorPersonByDocument: state.Person.errorPersonByDocument,
            loadingPersonByDocument: state.Person.loadingPersonByDocument,
        });
    }), responsePersonByDocument = _a.responsePersonByDocument, errorPersonByDocument = _a.errorPersonByDocument, loadingPersonByDocument = _a.loadingPersonByDocument;
    useEffect(function () {
        if (trigger) {
            dispatch(personByDocument({
                enable: enable,
                page: page,
                limit: limit,
                document: document,
            }));
        }
    }, [trigger, document]);
    return {
        responsePersonByDocument: responsePersonByDocument,
        errorPersonByDocument: errorPersonByDocument,
        loadingPersonByDocument: loadingPersonByDocument,
    };
};
